class SubcategoriesScroll extends HTMLElement {
  constructor() {
    super();
    this.scrollContainer = this.querySelector('.js-subcategories-scroll');
    this.leftArrow = this.querySelector('.collection-subcategories__arrow--left');
    this.rightArrow = this.querySelector('.collection-subcategories__arrow--right');
    this.arrowsContainer = this.querySelector('.collection-subcategories__arrows');

    if (!this.scrollContainer || !this.leftArrow || !this.rightArrow || !this.arrowsContainer) return;

    this.onScroll = this.updateArrows.bind(this);
    this.onResize = this.checkOverflow.bind(this);

    this.leftArrow.addEventListener('click', () => this.scroll('left'));
    this.rightArrow.addEventListener('click', () => this.scroll('right'));
    this.scrollContainer.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onResize);

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => this.checkOverflow());
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.scrollContainer);
    }

    this.initSubcategoriesLayout();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
    if (this.scrollContainer && this.onScroll) {
      this.scrollContainer.removeEventListener('scroll', this.onScroll);
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  initSubcategoriesLayout() {
    const run = () => {
      this.checkOverflow();
      this.scrollToActiveSubcategory();
    };

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(run);
    } else {
      setTimeout(run, 100);
    }

    window.addEventListener('load', run, { once: true });
  }

  scrollToActiveSubcategory() {
    const activeLink = this.scrollContainer.querySelector('.collection-subcategories__link.active');
    if (!activeLink) return;

    const listItem = activeLink.closest('li');
    if (!listItem) return;

    const container = this.scrollContainer;
    const containerRect = container.getBoundingClientRect();
    const itemRect = listItem.getBoundingClientRect();
    const targetScroll = itemRect.left - containerRect.left + container.scrollLeft;
    const maxScroll = container.scrollWidth - container.clientWidth;

    container.scrollLeft = Math.min(Math.max(0, targetScroll), maxScroll);
    this.updateArrows();
  }

  scroll(direction) {
    const scrollAmount = 300; // Pixels to scroll
    if (direction === 'left') {
      this.scrollContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      this.scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  }

  updateArrows() {
    if (this.scrollContainer.scrollLeft <= 0) {
      this.leftArrow.disabled = true;
    } else {
      this.leftArrow.disabled = false;
    }

    if (this.scrollContainer.scrollLeft + this.scrollContainer.clientWidth >= this.scrollContainer.scrollWidth - 1) {
      this.rightArrow.disabled = true;
    } else {
      this.rightArrow.disabled = false;
    }
  }

  checkOverflow() {
    if (this.scrollContainer.scrollWidth > this.scrollContainer.clientWidth) {
      this.arrowsContainer.style.display = 'flex';
    } else {
      this.arrowsContainer.style.display = 'none';
    }
    this.updateArrows();
  }
}
customElements.define('subcategories-scroll', SubcategoriesScroll);
